<template>
<div>
  <h2>The Library</h2>
  <p>This was an early test of the "crowdcomic" idea, done via a series of Facebook posts. Enjoy!</p>
  <hr>
  <div class="panel">
    <img src="/static/oldcomics/0.png" alt="panel" />
    <p class="description">You wake up in a dark hallway. The floor under your hands is cool and rough, like old hewn stone. Next to you is a BACKPACK. To your right is a DOOR, beyond which you can see some flickering light, as though a fire burns just beyond its threshold. You cannot see to your left right now - it is too dark. You cannot remember how you got here.</p>
    <p class="instruction"><span class="user">Seth J.</span>: look in backpack</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/1.png" alt="panel" />
    <p class="description">Your BACKPACK contains two items: A BOOK and a DAGGER. The book looks old, and you cannot make out the title in the darkness. The dagger has some runes imprinted down the side of its blade, although you cannot remember how to read them.</p>
    <p class="instruction"><span class="user">Karolina R</span>:  Take the dagger and go into the dark.</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/2.png" alt="panel" />
    <p class="description">You leave your backpack behind and venture into the darkness. The darkness is, like, really dark. You stumble and trip your way toward whatever is at the end of the corridor. You eventually bump into a door, but it is so dark here you don't know if you'll be able to open it.</p>
    <p class="instruction"><span class="user">Chelsea G</span>: Try to open the door.</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/3.png" alt="panel" />
    <p class="description">The door swings open readily, and reveals to you a massive library, bookshelves upon bookshelves reaching from floor to ceiling. Still clutching your dagger, your eyes quickly adjust to the light of the lanterns hanging from the ends of the rows, which cast a soft, warm light on the ancient tomes.</p>
    <p class="description">You hear a cackling laughter, like that of a small mischevious child, from the end of one of the rows. You cannot see whatever made the sound.</p>
    <p class="instruction"><span class="user">Stephanie V.</span>: Yap like a pomeranian and mark your territory.</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/4.png" alt="panel" />
    <p class="description">You draw a large "X" on the door while making the sounds of a small dog. Your outburst seems to have attracted the attention of the... whatever that little thing is hanging off the bookshelf at the end of the row. It doesn't look happy to see you.</p>
    <p class="instruction"><span class="user">Seth J.</span>: shank the filthy bastard cause hes different</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/5.png" alt="panel" />
    <p class="description">Just as you're about to set out on your murderous task, the IMP leaps forward, claws extended! With skill that you didn't know (rather, remember) you had, you instinctively slash out with your dagger, cutting the IMP across the face! With a "splat!" the DEAD IMP hits the wall, reduced to nothing more than a PILE OF GOO.</p>
    <p class="description">You now hear nothing but what sounds like someone tearing paper far across this room (which is quite large).</p>
    <p class="instruction"><span class="user">Chelsea G.</span>: Go to investigate where the paper tearing is coming from, carefully and quietly</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/6.png" alt="panel" />
    <p class="description">You make your way across the library floor, trying to make as little noise as possible. The books help, their dense pages muffling every sound you make.</p>
    <p class="description">Sure enough, there are two IMPs tearing apart a BOOK, stuffing the defiled pages into their gruesome mouths.</p>
    <p class="instruction"><span class="user">Stephanie V.</span>: Join them.</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/7.png" alt="panel" />
    <p class="description">The BOOK doesn't taste very good. The IMPs look at you skeptically, as though suspicious that you might be up to no good.</p>
    <p class="description">You feel guilty for eating the book.</p>
    <p class="instruction"><span class="user">Seth J.</span>: eat the imps to get the taste out</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/8.png" alt="panel" />
    <p class="description">You pick up the closest IMP, and lift it toward your mouth. It feels gooey in your fingers, like warm tapioca. As soon as the IMPs realize what you're trying to do, however, the IMP in your hands squeals violently, and both of them launch onto you, scratching at you with their tiny claws!</p>
    <p class="description">You are under attack!</p>
    <p class="instruction"><span class="user">Chelsea G.</span>: Run awaayyyyyyyy</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/9.png" alt="panel" />
    <p class="description">You run! The IMPs cling to your face and arm, their tiny claws digging into your skin. They seem surprised by this action and stop their imminent assault. You make your way down the row of books, toward one of the massive walls of the room you're in. You can see in front of you a dead end, where a bookcase stands in front of your path.</p>
    <p class="instruction"><span class="user">Chris P.</span>: Grab a book and start wailing on the imps</p>
  </div>
  <div class="panel">
    <img src="/static/oldcomics/10.png" alt="panel" />
    <p class="description">You stop at the end of the row of books, and - before the IMPs can react - you grab a BOOK off the shelf. You deliver a solid smack to the IMP on your head, reducing it to a PILE OF GOO! In the commotion, the other IMP leaps from your arm and starts scrambling off, following the wall that you're near toward a DOOR nested between even more bookshelves.</p>
    <p class="instruction"><span class="user">Chelsea G.</span>: Go through the door, bringing the book with as a weapon.</p>
    <p class="instruction"><span class="user">Chelsea G.</span>: After checking the door for traps.</p>
  </div>
  <p>The end!</p>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>
div.panel{
  border: 1px solid black;
  margin: 10px;
  padding: 10px;
}

p.instruction{
  padding: 10px;
  border-top: 1px solid black;
}

span.user{
  font-style:italic
}

img{
  width: 80%;
  height: 80%;
}
</style>



// WEBPACK FOOTER //
// TheLibrary.vue?502ae78a